import { render, staticRenderFns } from "./ProblemReason.vue?vue&type=template&id=b122a976&scoped=true&"
import script from "./ProblemReason.vue?vue&type=script&lang=js&"
export * from "./ProblemReason.vue?vue&type=script&lang=js&"
import style0 from "./ProblemReason.vue?vue&type=style&index=0&id=b122a976&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b122a976",
  null
  
)

export default component.exports